import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_5ABlue_5DRed = () => <CrossRoad coords="1729.000000, 764.000000"/>;

export default CrossRoad_5ABlue_5DRed;
